"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.snack = exports.create = exports.ISnackObj = void 0;
var React = require("react");
var ApSnackBox_1 = require("./ApSnackBox");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
// ISnackObj is a duplicate of the interface to populate a proper prop table in Snack.stories
exports.ISnackObj = [
    {
        defaultValue: 'false',
        description: 'The message to display',
        propType: {
            name: 'string',
        },
        property: 'message',
        required: true,
    },
    {
        defaultValue: 3,
        description: 'Time in seconds before animating off',
        propType: {
            name: 'number',
        },
        property: 'hideAfter',
        required: false,
    },
    {
        defaultValue: "\"" + constants_1.TOP_RIGHT + "\"",
        description: 'The position on screen',
        propType: {
            name: "\n        \"" + constants_1.TOP_LEFT + "\"\n      | \"" + constants_1.TOP_CENTER + "\"\n      | \"" + constants_1.TOP_RIGHT + "\"\n      | \"" + constants_1.BOTTOM_LEFT + "\"\n      | \"" + constants_1.BOTTOM_CENTER + "\"\n      | \"" + constants_1.BOTTOM_RIGHT + "\"",
        },
        property: 'position',
        required: false,
    },
];
exports.create = function (_a) {
    var message = _a.message, hideAfter = _a.hideAfter, id = _a.id, position = _a.position, suppressHide = _a.suppressHide, variant = _a.variant, custom = _a.custom, showIcon = _a.showIcon, button = _a.button;
    return __awaiter(void 0, void 0, void 0, function () {
        var defaultHide, hideTimeout, positionString, yPosition, xPosition, snackGroup, hideById, snackBox, hide;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!document.getElementById("" + constants_1.CONTAINER_CLASS_NAME)) return [3 /*break*/, 2];
                    return [4 /*yield*/, utils_1.createDOMContainer()];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    defaultHide = 3000;
                    hideTimeout = hideAfter ? hideAfter * 1000 : defaultHide;
                    positionString = position ? position.split('-') : constants_1.TOP_RIGHT.split('-');
                    yPosition = positionString[0];
                    xPosition = positionString[1];
                    snackGroup = document.getElementById(yPosition + "-" + xPosition);
                    hideById = function (elId) {
                        if (snackGroup && elId) {
                            var el_1 = document.getElementById("" + elId);
                            if (el_1) {
                                Object.assign(el_1.style, __assign({}, utils_1.getTransitionStyles.exiting[yPosition]));
                                setTimeout(function () { return snackGroup.removeChild(el_1); }, 300);
                            }
                        }
                    };
                    return [4 /*yield*/, utils_1.createDOMNode(React.createElement(ApSnackBox_1.SnackBox, { variant: variant, message: message, custom: custom, hide: hideById, id: id, showIcon: showIcon, button: button }))];
                case 3:
                    snackBox = _b.sent();
                    if (snackGroup && snackBox) {
                        Object.assign(snackBox.style, __assign({}, utils_1.getTransitionStyles.entering[yPosition]));
                        setTimeout(function () {
                            Object.assign(snackBox.style, __assign({}, utils_1.getTransitionStyles.entered[yPosition]));
                        }, 10);
                        snackGroup.appendChild(snackBox);
                        if (!suppressHide) {
                            setTimeout(function () { return hide(); }, hideTimeout);
                        }
                    }
                    hide = function () {
                        if (snackGroup && snackBox) {
                            Object.assign(snackBox.style, __assign({}, utils_1.getTransitionStyles.exiting[yPosition]));
                            setTimeout(function () { return snackGroup.removeChild(snackBox); }, 300);
                        }
                    };
                    return [2 /*return*/, {
                            defaultHide: defaultHide,
                            hideAfter: hideAfter,
                            hideTimeout: hideTimeout,
                            message: message,
                            position: position,
                            positionString: positionString,
                            snackBox: snackBox,
                            snackGroup: snackGroup,
                            variant: variant,
                            xPosition: xPosition,
                            yPosition: yPosition,
                        }];
            }
        });
    });
};
exports.snack = (_a = {},
    _a[constants_1.INFO] = function (_a) {
        var message = _a.message, position = _a.position, hideAfter = _a.hideAfter, showIcon = _a.showIcon, button = _a.button;
        exports.create({ message: message, position: position, hideAfter: hideAfter, showIcon: showIcon, button: button, variant: constants_1.INFO });
    },
    _a[constants_1.SUCCESS] = function (_a) {
        var message = _a.message, position = _a.position, hideAfter = _a.hideAfter, showIcon = _a.showIcon, button = _a.button;
        exports.create({ message: message, position: position, hideAfter: hideAfter, showIcon: showIcon, button: button, variant: constants_1.SUCCESS });
    },
    _a[constants_1.WARNING] = function (_a) {
        var message = _a.message, position = _a.position, hideAfter = _a.hideAfter, showIcon = _a.showIcon, button = _a.button;
        exports.create({ message: message, position: position, hideAfter: hideAfter, showIcon: showIcon, button: button, variant: constants_1.WARNING });
    },
    _a[constants_1.ERROR] = function (_a) {
        var message = _a.message, position = _a.position, hideAfter = _a.hideAfter, showIcon = _a.showIcon, button = _a.button;
        exports.create({ message: message, position: position, hideAfter: hideAfter, showIcon: showIcon, button: button, variant: constants_1.ERROR });
    },
    _a[constants_1.CUSTOM] = function (_a) {
        var message = _a.message, position = _a.position, hideAfter = _a.hideAfter, id = _a.id, custom = _a.custom, suppressHide = _a.suppressHide;
        return exports.create({
            custom: custom,
            hideAfter: hideAfter,
            id: id,
            message: message,
            position: position,
            suppressHide: suppressHide,
            variant: constants_1.CUSTOM,
        });
    },
    _a);
//# sourceMappingURL=ApSnack.js.map